import React from 'react';

import { yandexMetrica } from '../helpers';

export const useYandexMetricaScript = (
  yandexMetricaInstance?: ReturnType<typeof yandexMetrica>,
) => {
  const [isScriptReady, setIsScriptReady] = React.useState(false);

  React.useEffect(() => {
    if (!yandexMetricaInstance) {
    	return;
    }

    const scriptElement = yandexMetricaInstance.script();
    document.head.append(scriptElement);
    setIsScriptReady(true);
  }, [yandexMetricaInstance]);

  return isScriptReady;
};
